export interface INode {
    id: string;
    name: string;
    parentId?: string;
    children: INode[];
    model?: {};
    roles?: any[];
    isConditional?: boolean;
}

export class NodeModel implements INode {
    id: string;
    children: INode[];
    name: string;
    parentId?: string;
}

export interface INodeOptions {
    title?: string,
    objectName: string,
    enablePan?: boolean,
    zoom?: boolean,
    showAddChild: boolean;
    workflowType: string;
    metaData?: {
        [key: string]: any
    };
    status?: 'active' | 'inactive' | 'draft' | string;
    isDraftMode: boolean;
    autoSave?: boolean;
    workflowId?: number,
    viewMode: string | 'audit' | 'history' | 'form';
    tasksStatus?: object;
    audit?: {
        [key: string]: any
    }
}

export class NodeOptionsObject implements INodeOptions {
    enablePan = true;
    objectName = '';
    showAddChild = true;
    title = '';
    zoom = false;
    workflowType = '';
    metaData = undefined;
    status = '';
    isDraftMode = true;
    autoSave = true;
    workflowId: number = 0;
    viewMode: string = 'form';
    tasksStatus: object = {};
    audit: object = {};
    constructor(data: object = undefined) {
        if(data) {
            for( const key in data ) {
                if(this.hasOwnProperty(key)) {
                    this[key] = data[key];
                }
            }
        }
    }

}
